import { agent } from '@shared/services/agent';

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
}

export function createCheckoutSession(priceId: string, quantity: number): Promise<CheckoutSessionResponse> {
  return agent.requests.post('/api/stripe/create-checkout-session', {
    priceId: priceId,
    quantity: quantity,
  });
}

export function getCheckoutSession(sessionId: string) {
  return agent.requests.get(`/api/stripe/checkout-session?sessionId=${sessionId}`);
}

export function getCustomerPortal() {
  return agent.requests.get('/api/stripe/customer-portal')
}

export function changeSubscriptionPlan(tier: string) {
  return agent.requests.post('/api/stripe/change-plan', { tier });
}

// `users` is the requested number of paid user seats. The backend rounds it up to the next whole
// pack (of 10) and sets the Stripe pack quantity itself.
export function changeSubscriptionQuantity(users: number) {
  return agent.requests.post('/api/stripe/change-quantity', { quantity: users });
}

export interface InvoiceSummary {
  number: string;
  created: number;   // epoch seconds
  amount: number;    // smallest currency unit (e.g. pence/cents)
  currency: string;
  status: string;
  url: string;
}

export function getInvoices(): Promise<InvoiceSummary[]> {
  return agent.requests.get('/api/stripe/invoices');
}

export interface BankTransferEnquiry {
  tier: string;
  users: number;
}

// Notifies sales (sales@team-today.com) that the signed-in user wants to pay by bank transfer.
// The user/company is resolved server-side from the auth token; we only send the plan details.
export function sendBankTransferEnquiry(details: BankTransferEnquiry) {
  return agent.requests.post('/api/stripe/bank-transfer-enquiry', details);
}
